import { isNil } from 'lodash';
import React, { useCallback } from 'react';
import { useToast } from '@shared/components/toast';
import { useBillingContext } from '@shared/scenes/billing/provider';
import { useBusinessRole } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { useNavigateToRoute } from '@shared/util/navigation';
import { MBMetricsCounterComponent } from './component';

export function findMetric(type: string, data: MBAPI.ListUsageMetricsQuery): number {
  return data?.metrics?.find(m => m.type === type)?.value || 0;
}

export function useUpgrade(): () => void {
  const toast = useToast();
  const { isBusinessAdmin } = useBusinessRole();
  const navigateToBilling = useNavigateToRoute('Billing');
  return useCallback(() => {
    if (!isBusinessAdmin) {
      toast.show({
        style: 'confirmation',
        icon: 'exclamation-filled',
        message: i18n('billing.metricsCounter.contactAdminPrompt'),
      });
    } else {
      navigateToBilling();
    }
  }, [toast, isBusinessAdmin, navigateToBilling]);
}

export function MBMetricsCounter() {
  const handleUpgrade = useUpgrade();
  const { billing, loading } = useBillingContext();

  if (loading || billing.isPaidPlan !== false) {
    return null;
  }

  if (
    isNil(billing.messages) ||
    isNil(billing.messageLimit) ||
    isNil(billing.cards) ||
    isNil(billing.cardLimit) ||
    isNil(billing.storage) ||
    isNil(billing.storageLimit)
  ) {
    return null;
  }

  return (
    <MBMetricsCounterComponent
      messages={billing.messages}
      messageLimit={billing.messageLimit}
      cards={billing.cards}
      cardLimit={billing.cardLimit}
      storage={billing.storage}
      storageLimit={billing.storageLimit}
      onUpgrade={handleUpgrade}
    />
  );
}
